//CONSTANTS
import {
  GET_PLANS_CONTROL_SUCCESS,
  GET_CONTROL_PLAN_AND_CONTROLS_SUCCESS,
  POST_FILES_CONTROL_SUCCESS,
  DELETE_FILES_CONTROL_SUCCESS,
  CLEAN_FILES_CONTROL,
  GET_ALL_CONTROL_PLANS_AND_CONTROLS_SUCCESS,
  GET_CONTROL_AND_TEMPLATE_BY_ID_SUCCESS,
  GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS_SUCCESS,
  SET_CONTROLS_THAT_HAVE_RECOMMENDATIONS,
  GET_CONTROL_THREAD_BY_CONTROL_ID_SUCCESS,
  SET_IS_LOADING_CONTROL,
  GET_OVERALL_SYNTHESE_CONTROL_SUCCESS,
  SET_IS_LOADING_SYNTHESE,
} from "./constants"

const initialState = {
  listControlPlans: [],
  controlPlanWithControls: [],
  listFilesControl: [],
  listControlPlansWithControls: [],
  controlAndTemplate: {},
  controlsThatHaveRecommendations: [],
  controlThreadMessages: [],
  isLoadingControl: true,
  overallSyntheseControl: {},
  isLoadingSynthese: true,
}

function controlPlanReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_PLANS_CONTROL_SUCCESS:
      return {
        ...state,
        listControlPlans: payload,
      }
    case GET_CONTROL_PLAN_AND_CONTROLS_SUCCESS:
      return {
        ...state,
        controlPlanWithControls: payload,
      }
    case POST_FILES_CONTROL_SUCCESS:
      return {
        ...state,
        listFilesControl: [...state.listFilesControl, payload],
      }
    case DELETE_FILES_CONTROL_SUCCESS:
      return {
        ...state,
        listFilesControl: state.listFilesControl.filter(file => file.name !== payload),
      }
    case CLEAN_FILES_CONTROL:
      return {
        ...state,
        listFilesControl: [],
      }
    case GET_ALL_CONTROL_PLANS_AND_CONTROLS_SUCCESS:
      return {
        ...state,
        listControlPlansWithControls: payload,
      }
    case GET_CONTROL_AND_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        controlAndTemplate: payload,
      }
    case GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        controlsThatHaveRecommendations: payload,
      }
    case SET_CONTROLS_THAT_HAVE_RECOMMENDATIONS:
      return {
        ...state,
        controlsThatHaveRecommendations: payload,
      }
    case GET_CONTROL_THREAD_BY_CONTROL_ID_SUCCESS:
      return {
        ...state,
        controlThreadMessages: payload,
      }
    case GET_OVERALL_SYNTHESE_CONTROL_SUCCESS:
      return {
        ...state,
        overallSyntheseControl: payload,
      }
    case SET_IS_LOADING_CONTROL:
      return {
        ...state,
        isLoadingControl: payload,
      }
    case SET_IS_LOADING_SYNTHESE:
      return {
        ...state,
        isLoadingSynthese: payload,
      }
    default:
      return state
  }
}

export default controlPlanReducer
